import React from 'react';

import { useCmsContent } from '@src/contexts/cms-content-context';
import {
  PASSWORD_RULE_LOWERCASE,
  PASSWORD_RULE_NUMBERS,
  PASSWORD_RULE_SPECIAL_CHARACTERS,
  PASSWORD_RULE_UPPERCASE,
} from '@src/features/auth/constants';

import Rule from './rule';
import { RuleList } from './styles';
import { PasswordRulesProps } from './types';

const PasswordRules = ({ isTouched, error }: PasswordRulesProps) => {
  const content = useCmsContent();

  const hasPattern = (name: string) => {
    const patternError = error?.types?.['string.pattern.name'];

    if (!patternError) {
      return false;
    }

    if (Array.isArray(patternError)) {
      return patternError.includes(name);
    }

    return patternError === name;
  };

  const minLength = !error?.types?.minLength && !error?.types?.['string.min'];
  const hasLowerCase = !hasPattern(PASSWORD_RULE_LOWERCASE);
  const hasUpperCase = !hasPattern(PASSWORD_RULE_UPPERCASE);
  const hasNumbers = !hasPattern(PASSWORD_RULE_NUMBERS);
  const hasSpecialCharacters = !hasPattern(PASSWORD_RULE_SPECIAL_CHARACTERS);
  const isSameAsOldPassword = !!error?.types?.['any.invalid'];

  return (
    <RuleList>
      <Rule isTouched={isTouched} isValid={minLength}>
        {content.passwordRuleLength}
      </Rule>
      <Rule isTouched={isTouched} isValid={hasLowerCase && hasUpperCase}>
        {content.passwordRuleCase}
      </Rule>
      <Rule isTouched={isTouched} isValid={hasNumbers}>
        {content.passwordRuleNumbers}
      </Rule>
      <Rule isTouched={isTouched} isValid={hasSpecialCharacters}>
        {content.passwordRuleSpecialCharacters}
      </Rule>
      {isSameAsOldPassword && (
        <Rule isTouched={true} isValid={false}>
          {content.passwordRuleNew}
        </Rule>
      )}
    </RuleList>
  );
};
export default PasswordRules;
